import React, { useState, useEffect } from "react";

// Đổi tên class từ RSVP thành WeddingWishesForm để tránh ghi đè
function RSVP() {
  const [showFireworks, setShowFireworks] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const [fireworks, setFireworks] = useState([]);

  // Tạo hiệu ứng pháo hoa
  useEffect(() => {
    if (showFireworks) {
      const interval = setInterval(() => {
        setFireworks((prev) => {
          // Giới hạn số lượng pháo hoa hiển thị đồng thời
          if (prev.length >= 15) {
            const newFireworks = [...prev];
            newFireworks.shift(); // Xóa pháo hoa đầu tiên
            newFireworks.push(createFirework());
            return newFireworks;
          }
          return [...prev, createFirework()];
        });
      }, 300);

      return () => {
        clearInterval(interval);
        setFireworks([]);
      };
    }
  }, [showFireworks]);

  // Tạo dữ liệu cho một pháo hoa
  const createFirework = () => {
    const colors = [
      "#FFD700",
      "#FF1493",
      "#ff758c",
      "#ffffff",
      "#ffc3a0",
      "#FF4500",
      "#7FFFD4",
    ];
    return {
      id: Math.random().toString(36).substr(2, 9),
      left: Math.random() * 100,
      top: 40 + Math.random() * 40, // Giới hạn trong phần trên của màn hình
      size: 10 + Math.random() * 30,
      color: colors[Math.floor(Math.random() * colors.length)],
    };
  };

  // Hàm xử lý khi submit form
  const handleSubmit = (e) => {
    e.preventDefault();

    // Hiển thị thông báo cảm ơn và hiệu ứng pháo hoa
    setShowThankYou(true);
    setShowFireworks(true);

    // Sau 5 giây, ẩn hiệu ứng pháo hoa
    setTimeout(() => {
      setShowFireworks(false);
    }, 5000);

    // Reset form sau khi gửi
    setTimeout(() => {
      setShowThankYou(false);
      setName("");
      setMessage("");
    }, 6000);
  };

  return (
    <div
      id="wedding-wishes"
      className="wedding-section-padding bg-img bg-fixed wedding-background"
    >
      {/* Hiệu ứng pháo hoa */}
      {showFireworks && (
        <div className="wedding-fireworks-container">
          {fireworks.map((fw) => (
            <div
              key={fw.id}
              className="wedding-firework"
              style={{
                left: `${fw.left}%`,
                top: `${fw.top}%`,
                width: `${fw.size}px`,
                height: `${fw.size}px`,
                backgroundColor: fw.color,
              }}
            />
          ))}
        </div>
      )}

      <div className="wedding-container">
        <div className="wedding-row justify-content-center">
          <div className="wedding-col-md-6 bg-white wedding-form-container">
            {showThankYou ? (
              <div className="wedding-thank-you-message">
                <h3>Cảm ơn {name}!</h3>
                <p>
                  Chúng tôi đã nhận được lời chúc của bạn. Cảm ơn bạn đã chia sẻ
                  niềm vui cùng chúng tôi!
                </p>
                <div className="wedding-heart-animation">❤️</div>
              </div>
            ) : (
              <>
                <span className="wedding-title-meta text-center">
                  Lời chúc của bạn
                </span>
                <div className="wedding-decoration">💍 ❤️ 💍</div>
                <form
                  method="post"
                  className="wedding-form-row"
                  onSubmit={handleSubmit}
                >
                  <div className="wedding-form-group">
                    <input
                      type="text"
                      className="wedding-form-control"
                      placeholder="Nhập tên của bạn"
                      required
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>

                  <div className="wedding-form-group">
                    <textarea
                      name="message"
                      id="wedding-message"
                      cols="30"
                      rows="7"
                      className="wedding-form-control"
                      placeholder="Nhập lời chúc"
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                    ></textarea>
                  </div>
                  <div className="wedding-submit-container">
                    <button className="wedding-submit-button" type="submit">
                      <span className="wedding-button-text">Gửi lời chúc</span>
                      <span className="wedding-button-icon">💌</span>
                    </button>
                  </div>
                </form>
              </>
            )}
          </div>
        </div>
      </div>

      <style jsx>{`
        .wedding-section-padding {
          padding: 100px 0;
          background-image: url("/wedding-background.jpg");
          background-size: cover;
          position: relative;
          overflow: hidden;
        }

        .wedding-container {
          width: 85%;
          margin: 0 auto;
          position: relative;
          z-index: 1;
        }

        .wedding-row {
          display: flex;
          flex-wrap: wrap;
        }

        .justify-content-center {
          justify-content: center;
        }

        .wedding-col-md-6 {
          flex: 0 0 50%;
          max-width: 50%;
        }

        @media (max-width: 768px) {
          .wedding-col-md-6 {
            flex: 0 0 90%;
            max-width: 90%;
          }
        }

        .wedding-form-container {
          padding: 40px;
          border-radius: 15px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
          border: 1px solid #f8e6e6;
          background-color: rgba(255, 255, 255, 0.95);
          position: relative;
          overflow: hidden;
        }

        .wedding-form-container::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 5px;
          background: linear-gradient(
            90deg,
            #ff758c,
            #ff7eb3,
            #ff7eb3,
            #ff758c
          );
        }

        .wedding-title-meta {
          display: block;
          font-size: 24px;
          font-weight: 600;
          color: #ff758c;
          margin-bottom: 20px;
          font-family: "Playfair Display", serif;
          text-align: center;
        }

        .wedding-decoration {
          text-align: center;
          font-size: 24px;
          margin-bottom: 20px;
          animation: pulse 2s infinite ease-in-out;
        }

        .wedding-form-group {
          margin-bottom: 25px;
        }

        .wedding-form-control {
          width: 100%;
          padding: 15px;
          border: 1px solid #eee;
          border-radius: 8px;
          font-size: 16px;
          transition: all 0.3s;
        }

        .wedding-form-control:focus {
          border-color: #ff758c;
          box-shadow: 0 0 0 3px rgba(255, 117, 140, 0.2);
          outline: none;
        }

        .wedding-submit-container {
          text-align: center;
        }

        .wedding-submit-button {
          background: linear-gradient(45deg, #ff758c, #ff7eb3);
          color: white;
          border: none;
          padding: 15px 40px;
          font-size: 16px;
          border-radius: 50px;
          cursor: pointer;
          transition: all 0.3s;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 4px 15px rgba(255, 117, 140, 0.4);
        }

        .wedding-submit-button:hover {
          transform: translateY(-3px);
          box-shadow: 0 7px 20px rgba(255, 117, 140, 0.5);
        }

        .wedding-button-icon {
          margin-left: 10px;
          font-size: 18px;
        }

        .wedding-thank-you-message {
          text-align: center;
          padding: 20px;
        }

        .wedding-thank-you-message h3 {
          color: #ff758c;
          font-size: 28px;
          margin-bottom: 15px;
          font-family: "Playfair Display", serif;
        }

        .wedding-heart-animation {
          font-size: 40px;
          margin-top: 20px;
          animation: heartbeat 1.5s infinite ease-in-out;
        }

        /* Hiệu ứng pháo hoa */
        .wedding-fireworks-container {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          pointer-events: none;
          z-index: 100;
        }

        .wedding-firework {
          position: absolute;
          border-radius: 50%;
          transform: scale(0);
          opacity: 0;
          animation: firework 1s ease-out forwards;
        }

        @keyframes firework {
          0% {
            transform: scale(0);
            opacity: 1;
            box-shadow: 0 0 0 0px rgba(255, 255, 255, 0.5);
          }
          50% {
            opacity: 1;
          }
          100% {
            transform: scale(1);
            opacity: 0;
            box-shadow: 0 0 0 20px rgba(255, 255, 255, 0);
          }
        }

        @keyframes pulse {
          0% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.1);
          }
          100% {
            transform: scale(1);
          }
        }

        @keyframes heartbeat {
          0% {
            transform: scale(1);
          }
          25% {
            transform: scale(1.2);
          }
          50% {
            transform: scale(1);
          }
          75% {
            transform: scale(1.2);
          }
          100% {
            transform: scale(1);
          }
        }
      `}</style>
    </div>
  );
}

export default RSVP;
